import React, { useEffect, useRef, useState } from "react";
import CustomCalendar from "./CustomCalander";
import date from "../images/calendar.png";

const DatePickerWithInput = ({ label, value, onChange }) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleInputClick = () => {
    setShowCalendar(true);
  };

  const handleDateSelect = (date) => {
    onChange(date);
    setShowCalendar(false);
    inputRef.current.focus();
  };

  return (
    <div className="relative">
      <label className="block text-sm font-QSemiBold text-gray-700 mb-1">
        {label === "From Date"
          ? "From Date"
          : label === "To Date"
            ? "To Date"
            : "Date"}
      </label>
      <div className="relative">
        <input
          ref={inputRef}
          value={value || new Date().toISOString().split("T")[0]}
          onChange={(e) => onChange(e.target.value)}
          onClick={handleInputClick}
          className="w-full text-center border text-sm text-gray-500 tracking-tight font-QMedium border-gray-200 rounded-xl pl-4 pr-10 py-3  outline-none transition appearance-none bg-white"
        />
        <div className="absolute right-3 top-2.5 text-gray-400 pointer-events-none">
          <img src={date} className="w-7 h-7" alt="" />
        </div>
      </div>

      {showCalendar && (
        <div
          ref={calendarRef}
          className="absolute z-30 mt-2 w-full bg-white rounded-xl shadow-lg border border-gray-200"
        >
          <CustomCalendar
            selectedDate={value || new Date().toISOString().split("T")[0]}
            onChange={handleDateSelect}
          />
        </div>
      )}
    </div>
  );
};

export default DatePickerWithInput;
